import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button/Button';
import { tr } from '../utils/locale';
import Picto from '../../images/offlinechat/sf-chat.png';
import Favicon from '../../images/offlinechat/favicon.png';

class OfflineChatBot extends React.Component {
    constructor(props) {
        super(props);
        this.state = { open: false };
    }

    toggle = () => {
        const { open } = this.state;
        this.setState({ open: !open });
    };

    render() {
        const { iframeBaseUrl } = this.props;
        const { open } = this.state;
        const title = tr('Chat with us');
        return (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
            <div className={`sf-chat ${open && 'sf-chat--open'}`}>
                <div
                    className="sf-chat__button"
                    onKeyDown={() => {}}
                    tabIndex="-1"
                    role="button"
                    style={{ display: !open ? 'flex' : 'none' }}
                    onClick={this.toggle}
                >
                    <img className="sf-chat__button__icon" src={Picto} alt={title} />
                    <span className="sf-chat__button__label">{title}</span>
                </div>

                <div className="sf-chat__wrapper" style={{ display: open ? 'flex' : 'none' }}>
                    <div className="sf-chat__header">
                        <img className="sf-chat__header__favicon" src={Favicon} alt={title} />
                        <span className="sf-chat__header__title">{title}</span>
                        <Button
                            type="transparent"
                            className="sf-chat__header__action"
                            icon="close"
                            onClick={() => this.setState({ open: false })}
                        />
                    </div>
                    <div className="sf-chat__body">
                        {iframeBaseUrl ? (
                            <iframe
                                title="support-iframe"
                                id="support_iframe"
                                src={`${iframeBaseUrl}/support_xs.html?retURL=${iframeBaseUrl}/support_closed.html`}
                            />
                        ) : (
                            <iframe
                                title="pardot-chat"
                                id="pardot"
                                src="https://mkg.woosmap.com/l/1018782/2023-06-25/dwt8"
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

OfflineChatBot.propTypes = {
    iframeBaseUrl: PropTypes.string,
};

OfflineChatBot.defaultProps = {
    iframeBaseUrl: null,
};

export default OfflineChatBot;
